import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets.app/images/play.svg'


const _hoisted_1 = {
  key: 0,
  class: "notification v-fade"
}
const _hoisted_2 = { class: "notification__content" }
const _hoisted_3 = {
  key: 0,
  class: "notification__close-btn"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "notification__close-icon iconfont iclose" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "notification__play-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_7 = { class: "notification__text-box" }
const _hoisted_8 = { class: "notification__title" }
const _hoisted_9 = { class: "notification__text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Lorem ipsum dolor", -1)
const _hoisted_11 = { class: "notification__btn-box" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btns btns--large"
}, "Learn More", -1)

import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBox',
  props: {
    hideCloseButton: { type: Boolean }
  },
  setup(__props: any) {



const visible = ref(true)

function hide(): void {
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            (!__props.hideCloseButton)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("a", {
                    class: "notification__close",
                    onClick: hide
                  }, _hoisted_5)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "icon", {}, () => [
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, [
                _renderSlot(_ctx.$slots, "title", {}, () => [
                  _createTextVNode(" Introducing Podcasts: Meet the new content platform available now on Shortform! ")
                ])
              ]),
              _createElementVNode("p", _hoisted_9, [
                _renderSlot(_ctx.$slots, "text", {}, () => [
                  _hoisted_10,
                  _createTextVNode(" Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lectus a laoreet habitasse sed rutrum urna. Ut quam eget aliquam integer ut orci proin facilisis. ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _renderSlot(_ctx.$slots, "link", {}, () => [
                _hoisted_12
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})